package com.svdsak.style

import com.varabyte.kobweb.compose.css.Visibility
import com.varabyte.kobweb.compose.css.functions.opacity
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.transform
import com.varabyte.kobweb.compose.ui.modifiers.translateX
import com.varabyte.kobweb.compose.ui.modifiers.translateY
import com.varabyte.kobweb.compose.ui.modifiers.visibility
import com.varabyte.kobweb.silk.style.animation.Keyframes
import org.jetbrains.compose.web.css.percent

val slideLeft = Keyframes {
    from {
        Modifier
            .translateX(10.percent)
    }
    to {
        Modifier
            .visibility(Visibility.Visible)
    }
}

val slideRight = Keyframes {
    from {
        Modifier
            .translateX((-10).percent)
    }

    to {
        Modifier
    }
}

val slideUp = Keyframes {
    from {
        Modifier
            .translateY(30.percent)
    }
    to {
        Modifier
    }
}

val slideDown = Keyframes {
    from {
        Modifier
            .translateY((-30).percent)
    }
    to {
        Modifier
    }
}

val zoomIn = Keyframes {
    from {
        Modifier
            .transform {
                scale(0.8)
                opacity(0)
            }
    }
    to {
        Modifier
            .transform {
                scale(1)
                opacity(1)
            }
    }
}
